// src/lib/ueberspannung.js
// ABSICHERUNG DES UEBERSPANNUNGSSCHUTZES (NSHV 03.5) - Anna-Lena 22.09.2026, Migration 69
//
// Der Monteur traegt Hersteller, Typ und die vorhandene Sicherung ein. Den Soll-Wert
// (groesste zulaessige Vorsicherung laut Hersteller) holt die App aus der Tabelle
// ueberspannung_sicherungen. Kennt sie den Typ nicht, traegt das Buero den Soll-Wert
// ein - und die App merkt ihn sich fuer das naechste Mal.
// Bewertung: Ist = Soll = i.O., sonst (kleiner oder groesser) n.i.O. Ohne Soll:
// "Bewertung durch Büro".

import { supabase, withTimeout, zahlAusEingabe } from './supabase';

export const UESP_POS = '03.5';
export const UESP_MODUL = '03-NSHV';
export const UESP_OFFEN = 'Bewertung durch Büro';
const CACHE = 'etb-ueberspannung-sicherungen';

const schluessel = (h, t) => String(h || '').trim().toLowerCase() + '|' + String(t || '').trim().toLowerCase();

let liste = null;
function gemerkt() {
  try { return JSON.parse(localStorage.getItem(CACHE) || 'null'); } catch { return null; }
}

// Alle bekannten Typen (mit Netz frisch, sonst der gemerkte Stand).
export async function sicherungenLaden(frisch = false) {
  if (liste && !frisch) return liste;
  try {
    const { data, error } = await withTimeout(supabase.from('ueberspannung_sicherungen')
      .select('*').order('hersteller').order('typ'), 20000, 'Überspannungsschutz laden');
    if (error) throw error;
    liste = data || [];
    try { localStorage.setItem(CACHE, JSON.stringify(liste)); } catch { /* nur Zwischenspeicher */ }
  } catch {
    liste = gemerkt() || [];
  }
  return liste;
}

export async function sollNachschlagen(hersteller, typ) {
  if (!String(hersteller || '').trim() || !String(typ || '').trim()) return null;
  const k = schluessel(hersteller, typ);
  const eintrag = (await sicherungenLaden()).find(e => schluessel(e.hersteller, e.typ) === k);
  return eintrag ? Number(eintrag.soll_a) : null;
}

// Buero: Soll-Wert fuer diesen Typ merken (neu oder korrigiert).
export async function sollMerken(hersteller, typ, soll) {
  const h = String(hersteller || '').trim();
  const t = String(typ || '').trim();
  const s = zahlAusEingabe(soll);
  if (!h || !t || !(s > 0)) return;
  const alle = await sicherungenLaden(true);
  const vorhanden = alle.find(e => schluessel(e.hersteller, e.typ) === schluessel(h, t));
  if (vorhanden && Number(vorhanden.soll_a) === s) return;
  const q = vorhanden
    ? supabase.from('ueberspannung_sicherungen').update({ soll_a: s, geaendert_am: new Date().toISOString() }).eq('id', vorhanden.id)
    : supabase.from('ueberspannung_sicherungen').insert({ hersteller: h, typ: t, soll_a: s });
  const { error } = await withTimeout(q, 20000, 'Soll-Wert merken');
  if (error) throw error;
  await sicherungenLaden(true);
}

export async function sicherungLoeschen(id) {
  const { error } = await withTimeout(supabase.from('ueberspannung_sicherungen').delete().eq('id', id), 20000, 'Löschen');
  if (error) throw error;
  await sicherungenLaden(true);
}

const zahl = (v) => { const n = zahlAusEingabe(v); return n == null || isNaN(n) ? null : n; };
const text = (n) => String(n).replace('.', ',');

// Bewertung aus den Zusatzwerten. Liefert die Felder, die am Pruefpunkt zu setzen
// sind - oder null, wenn noch nichts eingetragen ist. bemerkung nur, wenn der
// Pruefpunkt keine eigene (manuelle) Bemerkung hat.
export function uespBewertung(werte, bisherigeBemerkung) {
  const w = werte || {};
  const ist = zahl(w.ist_a);
  const soll = zahl(w.soll_a);
  const eigene = bisherigeBemerkung && !String(bisherigeBemerkung).startsWith('Auto-Bewertung:');
  if (ist != null && soll != null) {
    // Nur GENAU der Herstellerwert ist in Ordnung (Anna-Lena 22.09.2026: "kleiner ist
    // nicht in Ordnung, nur wenn ist = soll dann i.O.").
    const ok = Math.abs(ist - soll) < 0.001;
    return {
      wert_auswahl: ok ? 'i.O.' : 'n.i.O.',
      in_ordnung: ok,
      wert_modifiers: [],
      ...(eigene ? {} : { bemerkung: 'Auto-Bewertung: Sicherung ' + text(ist) + ' A, laut Hersteller ' + text(soll)
        + ' A' + (ok ? '.' : ist > soll ? ' – zu groß.' : ' – zu klein.') }),
    };
  }
  if (ist != null || String(w.hersteller || '').trim() || String(w.typ || '').trim()) {
    return { wert_auswahl: UESP_OFFEN, in_ordnung: null, wert_modifiers: [],
      ...(eigene ? {} : { bemerkung: null }) };
  }
  return null;
}
